import { render, staticRenderFns } from "./AssignCustomerOwnership.vue?vue&type=template&id=558dd47e"
import script from "./AssignCustomerOwnership.vue?vue&type=script&lang=js"
export * from "./AssignCustomerOwnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports